module.exports = __webpack_public_path__ + "static/media/forest.8cbdd983.jpg";